import {useContextSelector} from "use-context-selector";
import {AppCurrencyContext} from "app/providers";
import {AppCalendarContext} from "../../Providers";

export default function useAppCalendarCellContent(main, compset) {
    const sliderColor = useContextSelector(AppCalendarContext, ({ state }) => state.sliderColor)
    const priceByNight = useContextSelector(AppCalendarContext, ({ state }) => state.priceByNight)
    const currency = useContextSelector(AppCurrencyContext, ({ state }) => state.currency)

    const price = (!priceByNight ? main?.priceDashboard : main?.priceDashboardNight) || 0
    const comp = compset.avg_min_compset_prices
    const percentComp = (comp * 100 / main?.priceDashboard) - 100
    const colorComp = main?.priceDashboard && percentComp < sliderColor[0] ? 'bg-error' :
        main?.priceDashboard && percentComp > sliderColor[1] ? 'bg-success' : 'bg-warn'


    return {
        price, colorComp, percentComp, comp, currency
    }

}